// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dt9t","textarea":"styles_textarea__2rhLb"};